import { render } from "./YoutubeEmbed.vue?vue&type=template&id=6b4bd1f8"
import script from "./YoutubeEmbed.vue?vue&type=script&lang=js"
export * from "./YoutubeEmbed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rigun/MyData/project/masehi-kudus/sch-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__